// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".panel-button-group[data-v-58dd37af]{display:flex;align-items:flex-end;justify-content:center;font-size:14px;height:23px;margin-right:-15px;margin-left:-15px;color:#5fb8ee;padding-bottom:2px;cursor:pointer}.panel-button-group .ico[data-v-58dd37af]:not(:only-child){margin-left:5px}", ""]);
// Exports
module.exports = exports;
